// import Vue from 'vue'
// import VueRouter from 'vue-router'

// Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const routes = [{
        path: '/',
        redirect: {
            name: "broadcast"
        }
    },
    {
        path: '/broadcast',
        name: 'broadcast',
        component: () =>
            import ('@/components/information/broadcast.vue'),
    },
    {
        path: '/project',
        name: 'project',
        component: () =>
            import ('@/components/information/project.vue'),
    },
    {
        path: '/financing',
        name: 'financing',
        component: () =>
            import ('@/components/information/financing.vue'),
    },
    {
        path: '/interview',
        name: 'interview',
        component: () => import('@/components/information/interview.vue'),
      },
    {
        path: '/report',
        name: 'report',
        component: () =>
            import ('@/components/research/report.vue'),
    },
    {
        path: '/Research',
        name: 'Research',
        component: () =>
            import ('@/components/research/Research.vue'),
    },
    {
        path: '/sycase',
        name: 'sycase',
        component: () =>
            import ('@/components/research/sycase.vue'),
    },
    {
        path: '/Practical',
        name: 'Practical',
        component: () =>
            import ('@/components/research/Practical.vue'),
    },
    {
        path: '/exposure',
        name: 'exposure',
        component: () =>
            import ('@/components/complaints/exposure.vue'),
    },
    {
        path: '/complainList',
        name: 'complainList',
        component: () =>
            import ('@/components/complaints/complainList.vue'),
    },
    {
        path: '/rating',
        name: 'rating',
        component: () =>
            import ('@/components/complaints/rating.vue'),
    },
    {
        path: '/industry',
        name: 'industry',
        component: () =>
            import ('@/components/data/industry.vue'),
    },
    {
        path: '/financeData',
        name: 'financeData',
        component: () =>
            import ('@/components/data/financeData.vue'),
    },
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes,
})

export default router